module.exports = __webpack_public_path__ + "img/step2-1.df109959.png";